import React from 'react';
import { useProjectCollection } from '../lib/projectData';
import '../styles/theme.css';
import '../styles/Dashboard.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import DashboardContinuePanel from '../components/DashboardContinuePanel';
import DashboardBalanceGauge from '../components/DashboardBalanceGauge';
import DashboardTransactionLedger from '../components/DashboardTransactionLedger';
/* IMPORTS */

function DashboardPage() {
  const { data: accounts } = useProjectCollection('client_accounts');
  const account = Array.isArray(accounts)
    ? accounts.find((item) => item && item.id === 'acct-4471') || accounts[0] || null
    : null;

  return (
    <div className="da-root">
      <div id="dashboardheader" className="da-slot-dashboardheader">
        <Navbar activePage={"Dashboard"} />
      </div>
      <div className="da-layout-1">
        <div id="dashboardbalancegauge" className="da-slot-dashboardbalancegauge">
          <DashboardBalanceGauge />
        </div>
        <div id="dashboardtransactionledger" className="da-slot-dashboardtransactionledger">
          <DashboardTransactionLedger
            accountId={account && account.id}
            openingBalance={account && account.balance}
          />
        </div>
      </div>
      <div id="dashboardcontinuepanel" className="da-slot-dashboardcontinuepanel">
        <DashboardContinuePanel />
      </div>
      <div id="dashboardfooter" className="da-slot-dashboardfooter">
        <Footer />
      </div>
    </div>
  );
}

export default DashboardPage;